<template>
  <div class="ergo4 text--secondary" align="center">
    <!-- <Header /> -->
    <v-row no-gutters>
      <v-col :cols="12">
        <div class="grid-container">
          <div v-for="(star, index) in initialStars" :key="index" :class="star">
            <v-icon v-for="i in index + 1" :key="i">mdi-star</v-icon>
          </div>
          <div class="tile life-av">
            <v-row justify="center" align-content="center" align="center">
              <v-col
                :cols="12"
                :lg="4"
                :md="6"
                :sm="12"
                class="pl-lg-8 text-sm-center"
              >
                <img
                  src="./../assets/life-av-new.png"
                  height="60px"
                  class="d-inline-block"
                />
              </v-col>
              <v-col class="pl-md-0 mr-md-1">
                Ubezpieczenie życia
              </v-col>
            </v-row>
          </div>
          <div class="tile body-av">
            <v-row justify="center" align-content="center" align="center">
              <v-col
                :cols="12"
                :lg="4"
                :md="6"
                :sm="12"
                class="pl-lg-8 text-sm-center"
              >
                <img
                  src="./../assets/body-av-new.png"
                  height="60px"
                  class="d-inline-block"
                />
              </v-col>
              <v-col class="pl-md-0 mr-md-1">
                Uszkodzenie ciała<br />i&nbsp;niezdolność do&nbsp;pracy
              </v-col>
            </v-row>
          </div>
          <div class="tile sick-av">
            <v-row justify="center" align-content="center" align="center">
              <v-col
                :cols="12"
                :lg="4"
                :md="6"
                :sm="12"
                class="pl-lg-8 text-sm-center"
              >
                <img
                  src="./../assets/sick-av-new.png"
                  height="60px"
                  class="d-inline-block"
                />
              </v-col>
              <v-col class="pl-md-0 mr-md-1">
                Poważne zachorowanie
              </v-col>
            </v-row>
          </div>
          <div class="tile child-av">
            <v-row
              justify="center"
              align-content="center"
              align="center"
              v-resize="onResize"
            >
              <v-col
                :cols="12"
                :lg="4"
                :md="6"
                :sm="12"
                class="pl-lg-8 text-sm-center"
              >
                <img
                  src="./../assets/child-av-new.png"
                  height="60px"
                  class="d-inline-block"
                />
              </v-col>
              <v-col class="pl-md-0" :cols="12" :lg="8" :md="6" :sm="12"
                >Zdrowie<br />dziecka
              </v-col>
            </v-row>
          </div>
          <div class="tile best-doctors-av">
            <v-row justify="center" align-content="center" align="center">
              <v-col
                :cols="12"
                :lg="4"
                :md="6"
                :sm="12"
                class="pl-lg-8 pl-sm-0 text-sm-center"
              >
                <img
                  src="./../assets/globalDoctors-av.png"
                  :height="windowSize.x > 700 ? '60px' : '40px'"
                  class="d-inline-block ml-md-6 ml-sm-0"
                />
              </v-col>
              <v-col>&nbsp;</v-col>
            </v-row>
          </div>
          <tile-offer
            v-for="tile in initialData"
            :key="tile.location"
            :title="tile.title"
            :description="tile.description"
            :location="tile.location"
            @click.native="select(tile.page, tile.videoId)"
            class="tile"
            :class="{ selected: selectedPages.includes(tile.page) }"
          />
        </div>
      </v-col>
    </v-row>
    <v-scale-transition>
      <v-row class="btn-generate mt-2" no-gutters>
        <v-col :lg="6" :md="6" :sm="12" class="text-md-right pr-md-1">
          <v-btn
            color="white"
            tile
            @click="merge(startPage, selectedPages, originalPDF)"
            :large="windowSize.x > 700"
            :block="windowSize.x <= 700"
            v-if="generateSheet"
            style="border: 1px solid RGBA(191, 21, 40, 1) !important; text-transform: none; box-shadow: none;"
          >
            Generuj PDF z opisem pakietu
          </v-btn>
        </v-col>
        <v-col
          :lg="6"
          :md="6"
          :sm="12"
          class="text-md-left pl-md-1 pt-sm-1 pt-md-0"
        >
          <v-btn
            color="white"
            tile
            :href="
              `https://ergo4-wideooferta.ergohestia.pl/#/watch?v=${this.videoStr}`
            "
            target="_blank"
            :large="windowSize.x > 700"
            :block="windowSize.x <= 700"
            v-if="generateSheet"
            style="border: 1px solid RGBA(191, 21, 40, 1) !important; text-transform: none; box-shadow: none; min-width: 276px"
          >
            Przejdź do wideo
          </v-btn>
        </v-col>
      </v-row>
    </v-scale-transition>
    <v-snackbar v-model="snackbar" :timeout="timeout" top>
      Nie przypisano strony z PDF danemu kafelkowi.
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          :loading="generateLoading"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Zamknij
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import InitialServices from "../services/InitialServices";
import PDFServices from "../services/PDFServices";
// import Header from "../components/Header";
import TileOffer from "../components/TileOffer";

export default {
  name: "ergo4",
  components: {
    // Header,
    TileOffer
  },
  data() {
    return {
      initialData: [],
      initialStars: [],
      pdfPages: [],
      selectedPages: [],
      startPage: 1,
      merged: "",
      snackbar: false,
      timeout: 5000,
      fileName: "ERGO4 - Opis pakietu",
      originalPDF: "/ERGO 4 - prospekt informacyjny GD 210115.pdf",
      generateLoading: false,
      videoStr: "",
      windowSize: {
        x: "",
        y: ""
      }
    };
  },
  computed: {
    generateSheet() {
      return !!this.selectedPages.length;
    }
  },
  async beforeMount() {
    this.initialData = await InitialServices.populateTiles();
    this.initialStars = await InitialServices.populateStars();
  },
  mounted() {
    this.onResize();
  },

  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    select(index, videoId) {
      this.snackbar = false;
      this.videoId += videoId;
      if (index) {
        if (this.selectedPages.includes(index)) {
          let indexOfPage = this.selectedPages.indexOf(index);
          this.selectedPages.splice(indexOfPage, 1);
        } else {
          this.selectedPages.push(index);
        }
      } else {
        this.snackbar = true;
      }

      if (videoId) {
        if (this.videoStr.includes(videoId)) {
          let indexOfVid = this.videoStr.indexOf(videoId);
          let videoStrToArray = this.videoStr.split("");
          videoStrToArray.splice(indexOfVid, 1);
          this.videoStr = videoStrToArray
            .sort()
            .join("")
            .replaceAll(",", "");
        } else {
          this.videoStr += videoId;
          this.videoStr = this.videoStr
            .split("")
            .sort()
            .join("")
            .replaceAll(",", "");
        }
      }
    },

    prepareArrayOfPages(startPage, pages) {
      pages.sort();
      const selectedPages = pages.map(el => el - 1);
      selectedPages.unshift(startPage - 1);
      selectedPages.sort((a, b) => a - b);
      return selectedPages;
    },

    async merge(startPage, selectedPages, originalPDF) {
      this.generateLoading = true;
      const pagesToMerge = this.prepareArrayOfPages(startPage, selectedPages);
      PDFServices.mergePages(pagesToMerge, originalPDF).then(resp => {
        this.downloadPDF(resp);
      });
    },

    downloadPDF(base64ToMerge) {
      const linkSource = base64ToMerge;
      const downloadLink = document.createElement("a");
      const fileName = `${this.fileName}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }
};
</script>
<style lang="scss">
.eh-logo-wrapper {
  max-height: 177px;
  text-align: right;
}

.ergo4 {
  color: rgb(87, 87, 87) !important;
  .grid-container {
    display: grid;
    grid-template-areas:
      "empty star-one star-two star-three"
      "life-av life-one life-two life-three"
      "body-av body-one body-two body-three"
      "sick-av sick-one sick-two sick-three"
      "child-av child-one child-two child-three"
      "gap gap gap gap"
      "bestDoctors-av bestDoctors-one bestDoctors-two bestDoctors-three";
    grid-template-rows: 50px 1fr 1fr 1fr 1fr 0px 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    color: rgb(87, 87, 87) !important;
    font-size: 14px;

    & > .tile {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      border-top: 1px solid RGBA(213, 213, 213, 1);
      border-left: 1px solid RGBA(213, 213, 213, 1);
      padding: 9px 9px;
      text-align: left;
      transition: all 0.2s;
      max-height: 195px;

      &:hover {
        background-color: RGBA(191, 21, 40, 0.8);
        border: 1px solid RGBA(191, 21, 40, 1);
        color: #eee;
        cursor: pointer;
      }

      .tile-title {
        margin-bottom: 10px;
      }
    }

    .empty {
      grid-area: empty;
      border: none;
      &:hover {
        background-color: RGBA(0, 0, 0, 0);
        cursor: initial;
      }
    }

    .star-styling {
      display: flex;
      flex-direction: initial;
      align-content: flex-end;
      justify-content: center;
      padding: 8px 8px;
      text-align: center;

      .v-icon {
        color: RGBA(191, 21, 40, 1);
        margin: 0 4px;
        font-size: 32px;
      }
    }

    .even-row {
      background-color: RGBA(245, 245, 245, 1);
    }

    .life-av,
    .body-av,
    .live-av,
    .sick-av,
    .child-av,
    .best-doctors-av {
      margin: 0;
      cursor: default;
      padding: 0;
      overflow: hidden !important;

      &:hover {
        background-color: inherit;
        color: rgba(0, 0, 0, 0.6);
        cursor: default;
        border-top: 1px solid RGBA(213, 213, 213, 1);
        border-left: 1px solid RGBA(213, 213, 213, 1);
        border-bottom: none;
        border-right: none;
      }

      img {
        margin: 0 auto;
      }
    }

    .body-av,
    .child-av {
      &:hover {
        background-color: RGBA(245, 245, 245, 1);
      }
    }

    .best-doctors-av {
      &:hover {
        border-bottom: 1px solid RGBA(213, 213, 213, 1);
      }
    }

    .star-one {
      @extend .star-styling;
      grid-area: star-one;
    }
    .star-two {
      @extend .star-styling;
      grid-area: star-two;
    }
    .star-three {
      @extend .star-styling;
      grid-area: star-three;
    }
    .life-av {
      grid-area: life-av;
    }
    .life-one {
      grid-area: life-one;
    }
    .life-two {
      grid-area: life-two;
    }
    .life-three {
      grid-area: life-three;
      border-right: 1px solid RGBA(213, 213, 213, 1);
    }
    .body-av {
      @extend .even-row;
      grid-area: body-av;
    }
    .body-one {
      @extend .even-row;
      grid-area: body-one;
    }

    .body-two {
      @extend .even-row;
      grid-area: body-two;
    }
    .body-three {
      @extend .even-row;
      grid-area: body-three;
      border-right: 1px solid RGBA(213, 213, 213, 1);
    }
    .sick-av {
      grid-area: sick-av;
    }
    .sick-one {
      grid-area: sick-one;
    }
    .sick-two {
      grid-area: sick-two;
    }
    .sick-three {
      grid-area: sick-three;
      border-right: 1px solid RGBA(213, 213, 213, 1);
    }
    .child-av {
      @extend .even-row;
      grid-area: child-av;
    }
    .child-one {
      @extend .even-row;
      grid-area: child-one;
    }
    .child-two {
      @extend .even-row;
      grid-area: child-two;
    }
    .child-three {
      @extend .even-row;
      grid-area: child-three;
      border-right: 1px solid RGBA(213, 213, 213, 1);
    }

    .best-doctors-av {
      grid-area: bestDoctors-av;
      border-bottom: 1px solid RGBA(213, 213, 213, 1);
    }
    .best-doctors-one {
      grid-area: bestDoctors-one;
      border-bottom: 1px solid RGBA(213, 213, 213, 1);
    }
    .best-doctors-two {
      grid-area: bestDoctors-two;
      border-bottom: 1px solid RGBA(213, 213, 213, 1);
    }
    .best-doctors-three {
      grid-area: bestDoctors-three;
      pointer-events: none;
      &:hover {
        cursor: default;
        background-color: #fff;
        border: none;
        border-top: 1px solid RGBA(213, 213, 213, 1);
        border-left: 1px solid RGBA(213, 213, 213, 1);
      }
    }

    .selected {
      background-color: RGBA(191, 21, 40, 1);
      color: #eee;
      border: 1px solid RGBA(191, 21, 40, 1);
      &:hover {
        background-color: RGBA(191, 21, 40, 1);
      }
    }
  }

  .btn-generate {
    position: relative;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    min-height: 70px;

    .v-btn__content {
      font-weight: 400;
      letter-spacing: initial;
      font-size: 1.1rem;
      color: #58585a;
    }
  }
  @media (min-width: 439px) and (max-width: 768px) {
    .grid-container {
      font-size: 10px;
      grid-template-rows: 25px 0.6fr 0.6fr 0.6fr 0.6fr 0px 0.6fr;

      & > .tile {
        padding: 6px;

        .tile-title {
          margin-bottom: 6px;
        }
      }
    }
  }

  @media (min-width: 0px) and (max-width: 768px) {
    .life-av,
    .body-av,
    .live-av,
    .sick-av,
    .child-av,
    .best-doctors-av {
      .pl-lg-8.text-sm-center.col-sm-12.col-md-6.col-lg-4.col-12 {
        padding-bottom: 0px;
      }

      img {
        margin: 0 auto;
        max-height: 40px !important;
      }
    }
  }

  @media (min-width: 0px) and (max-width: 438px) {
    &.container {
      padding: 0 !important;
    }
    .grid-container {
      grid-template-rows: 40px 1fr 1fr 1fr 1fr 0px 1fr;
      grid-template-columns: 21.01% 26.33% 26.33% 26.33%;
      font-size: 12px;

      .best-doctors-styling {
        height: auto;
      }

      & > .tile {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0px 2px;
        overflow: auto;
        text-align: left;

        .tile-title {
          margin-bottom: 8px;
        }
      }
    }

    .btn-generate {
      position: relative;
    }
  }

  @media (min-width: 0px) and (max-width: 1200px) {
    html.overflow-y-hidden {
      overflow-y: scroll !important;
    }

    .eh-logo-wrapper {
      text-align: center;
    }
  }

  @media (min-width: 700px) and (max-width: 1200px) {
    .grid-container {
      .tile-title {
        margin-bottom: 2px;
      }
    }
  }
}
</style>
